export default __webpack_public_path__ + "static/media/e1.bf60726e.png";